export default __webpack_public_path__ + "static/media/Facebook.b356b017.svg";